'use client'

import * as React from 'react'

import { useTemplatesPageContext } from '../context/templates-page'
import type { TextsType } from './index'

const TemplatesDetailModalLazy = React.lazy(() =>
  import('./template-details-modal').then(m => ({ default: m.TemplatesDetailModal })),
)

export function TemplatesDetailModalRenderer() {
  const {
    activeItem,
    items,
    lastLocation,
    setActiveItem,
    copyText,
    copyErrorPrefixText,
    copyErrorFallbackText,
    featureTexts,
    byText,
    customizeText,
    similarText,
    goToCategoryText,
    noResultsText,
    previousText,
    nextText,
    errorText,
  } = useTemplatesPageContext()

  const hit = items[activeItem]

  if (activeItem < 0 || !hit) {
    return null
  }

  const texts: TextsType = {
    copyText,
    copyErrorPrefixText,
    copyErrorFallbackText,
    featureTexts,
    byText,
    customizeText,
    similarText,
    goToCategoryText,
    noResultsText,
    previousText,
    nextText,
    errorText,
  }

  return (
    <React.Suspense fallback={null}>
      <TemplatesDetailModalLazy
        hit={hit}
        onClose={() => {
          if (lastLocation) {
            window.history.pushState({}, '', lastLocation)
          }
          setActiveItem(-1)
        }}
        {...texts}
      />
    </React.Suspense>
  )
}
